import React from 'react';
import { Section } from './ui/Section';
import { FileText, PenTool, Activity, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: <FileText size={24} data-id="element-104" />,
    title: 'Guión de apagado mental',
    time: '2 min',
    desc: 'corta la película interna'
  }, {
    icon: <PenTool size={24} data-id="element-105" />,
    title: 'Descarga escrita 2 columnas',
    time: '5 min',
    desc: "'lo que me apremia' → 'siguiente paso micro'"
  }, {
    icon: <Activity size={24} data-id="element-106" />,
    title: 'Micro-somático',
    time: '3 min',
    desc: '1 técnica corta para bajar alerta'
  }, {
    icon: <CheckCircle2 size={24} data-id="element-107" />,
    title: 'Cierre de bucle en 3 líneas',
    time: '2 min',
    desc: 'certeza simple para tu cerebro'
  }];
  return <Section background="gradient" className="relative overflow-hidden" data-id="element-108">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4a574] rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-109" />

      <div className="text-center mb-16" data-id="element-110">
        <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-111">
          Protocolo <span className="text-[#d4a574]" data-id="element-112">NOCHE-CERO</span>
        </h2>
        <div className="inline-block px-4 py-1 rounded-full border border-[#d4a574] text-[#d4a574] text-sm font-medium tracking-wide mb-8" data-id="element-113">
          12 MINUTOS
        </div>
        <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-114">
          Un ritual mínimo, en el mismo orden, que hace dos cosas:
        </p>
        <div className="flex flex-wrap justify-center gap-4 mt-6 text-white font-medium" data-id="element-115">
          <span className="flex items-center gap-2" data-id="element-116">
            <span className="w-2 h-2 bg-[#d4a574] rounded-full" data-id="element-117"></span>cierra
            bucles
          </span>
          <span className="flex items-center gap-2" data-id="element-118">
            <span className="w-2 h-2 bg-[#d4a574] rounded-full" data-id="element-119"></span>baja
            activación corporal
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-120">
        {steps.map((step, index) => <div key={index} className="flex items-start gap-4 bg-[#0f172a]/60 backdrop-blur-md p-6 rounded-lg border border-white/10 hover:border-[#d4a574]/40 transition-all duration-300" data-id="element-121">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#d4a574]/10 text-[#d4a574] flex items-center justify-center font-bold font-serif" data-id="element-122">
              {index + 1}
            </div>
            <div data-id="element-123">
              <div className="flex items-center gap-3 mb-1" data-id="element-124">
                <h3 className="font-serif text-lg text-white font-medium" data-id="element-125">
                  {step.title}
                </h3>
                <span className="text-xs text-slate-400 bg-white/5 px-2 py-0.5 rounded" data-id="element-126">
                  {step.time}
                </span>
              </div>
              <p className="text-slate-300" data-id="element-127">{step.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-128">
        <p className="text-xl font-serif text-white italic" data-id="element-129">
          "No necesitas hacerlo bonito. Necesitas hacerlo."
        </p>
      </div>
    </Section>;
}